import React from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {optionsTemplate, PercentFormatter} from "../../../utils/formatters";
import TextArea from "../../form/TextArea";
import CheckBox from "../../form/CheckBox";
import {isTrue} from "../../../utils/other";
import TextInput from "../../form/TextInput";

class RoyaltyForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="licensor"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            labelKey="name"
                            storeType="remote"
                            label="Jogtulajdonos"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="agent"
                            isClearable={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            labelKey="name"
                            storeType="remote"
                            label="Ügynök"
                        />
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            <Select
                                objectValue={true}
                                name="royaltytype"
                                value={this.props.values.royaltytype}
                                component="RoyaltyType"
                                storeType="local"
                                view={["object_component", "object_filter_field"]}
                                saveChanges={this.props.setFieldValue}
                                label="Típus"
                                {...this.props.getFieldProps("royaltytype")}
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            {(this.props.values.royaltytype || {}).object_component && <Select
                                objectValue={false}
                                name="object_component_id"
                                value={this.props.values.object_component_id}
                                component={(this.props.values.royaltytype || {}).object_component}
                                valueKey={(this.props.values.royaltytype || {}).object_filter_field}
                                optionsTemplate={optionsTemplate((this.props.values.royaltytype || {}).object_component)}
                                storeType="remote"
                                saveChanges={this.props.setFieldValue}
                                label={(this.props.values.royaltytype || {}).object_component === "product" ? "Termék" : "Komponens"}
                                {...this.props.getFieldProps("object_component_id")}
                            />}
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <TextInput
                                type="decimal"
                                name="overhead"
                                value={this.props.values.overhead ? this.props.values.overhead * 100 : 0}
                                formatter={PercentFormatter}
                                label="Levonás"
                                saveChanges={(field, overhead) => this.props.setFieldValue(field, "" + (overhead/100))}
                                {...this.props.getFieldProps("overhead")}
                            />
                        </div>
                    </div>
                    {/*<div className="col-sm-4">
                        <Select
                            objectValue={false}
                            name="calculation_type"
                            value={this.props.values.calculation_type}
                            optionname="calculation_type"
                            storeType="local"
                            saveChanges={this.props.setFieldValue}
                            label="Kalkuláció"
                            {...this.props.getFieldProps("calculation_type")}
                        />
                    </div>*/}
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextArea
                                name="comment"
                                value={this.props.values.comment}
                                label="Megjegyzés"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("comment")}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextArea
                                name="free_copy_comment"
                                value={this.props.values.free_copy_comment}
                                label="Tisztelet példány megjegyzés"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("free_copy_comment")}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <CheckBox
                                name="active"
                                value={!this.props.values[this.props.componentConfig.idfield] && this.props.values.active === undefined ? "1" : this.props.values.active}
                                label="Aktív"
                                saveChanges={(field, value) => this.props.setFieldValue(field, this.props.values[this.props.componentConfig.idfield] ? (isTrue(value) ? "1" : "0") : (isTrue(value) ? undefined : "0"))}
                                {...this.props.getFieldProps("active")}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RoyaltyForm);
